/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './loadingComponent.scss';

const LoadingErrorComponent = ({ isLoading }) => {
    if (isLoading) {
        return (
            <div className={`${styles.loadingContainer}`}>
                <p>Loading...</p>
            </div>
        );
    }
    return (
        <div className={`${styles.loadingContainer}`}>
            <p>No team leagues have been created, check back soon or contact a club organizer.</p>
        </div>
    );
};

export default LoadingErrorComponent;
